import moment from 'moment'
import reenviarContratoMixin from '@/mixins/reenviarContratoMixin'
import commercialHierarchy from '@/mixins/commercialHierarchy'
import { permiteEditar, removerCondicoesContratadas } from '../views/MinhasVendas'
import { ListaStatusPedido } from '../plugins/listaStatusStyles'
import { asyncAlert, alert as Aviso, getKeysOfPersistentes, notification, isVendaNaoGerada, existHierarchy } from '@/plugins/helpers'
import { mapState } from 'vuex'
import {
  FormasPagamento,
  StatusContrato,
  StatusPedido as Status
} from '@/plugins/constants'
import { AlertTypes } from '../plugins/alerts_types'
import { ERRO_PROPOSTA_EXCLUIDA } from '../enums/minhasVendas/mensagensErro'
// import { StatusPedido } from '../plugins/constants'
export default {

  computed: {
    ...mapState(['flavor', 'id_empresa', 'id_comissionado_venda', 'id_usuario_interno']),
    is_usuario_logado_hierarquia () {
      return existHierarchy(this.hierarquia_comercial)
    }
  },
  data: () => ({
    flavors: [],
    permite_venda_na_empresa: true,
    flavorsEEmpresas: [],
    podeRedirecionarParaTrocaAmbiente: false
  }),
  mixins: [reenviarContratoMixin, commercialHierarchy],
  methods: {

    async editar (venda, vendaRedirecionada = false) {
      const isVendaDoMesmoAmbiente = this.isVendaDoMesmoAmbiente(venda.id_flavor_utilizado_na_venda, venda.id_empresa_venda_logada) || vendaRedirecionada || this.is_usuario_logado_hierarquia
      if (venda.id_reserva) {
        if (isVendaNaoGerada(venda.status_pedido)) {
          let id_comissionado = null
          if (!this.is_usuario_logado_hierarquia) {
            id_comissionado = this.$session.get('id_comissionado_venda')
          } else {
            id_comissionado = venda.id_comissionado
          }
          this.$http.get(`/reservas/checar/${venda.id_reserva}/${id_comissionado}`).then(r => {
            if (!r.data.ok && venda.status_pedido !== Status.ReprovadoAnaliseCredito) {
              Aviso({
                title: 'O que deseja fazer?',
                text: 'A Reserva vinculada a essa venda não está mais válida',
                buttons: {
                  'Nova Reserva': () => {
                    if (isVendaDoMesmoAmbiente) {
                      this.irParaReservas()
                    } else {
                      this.alertRedirecionarAmbiente(venda)
                    }
                  },
                  'Apagar venda': {
                    color: 'error',
                    handler: () => {
                      this.deletar(venda.id_pedido)
                    }
                  }
                },
                showCloseButton: true
              })
            } else {
              this.editarVendaOuTrocaAmbiente(isVendaDoMesmoAmbiente, venda)
            }
          }).catch(() => {
            notification(AlertTypes.ERROR, 'Ocorreu uma falha na comunicação com o Newcon, tente novamente mais tarde! Caso persistir, favor entrar em contato com a Administradora.')
          })
        } else {
          this.editarVendaOuTrocaAmbiente(isVendaDoMesmoAmbiente, venda)
        }
      } else {
        if ((venda.cliente && venda.id_bem) || !isVendaNaoGerada(venda.status_pedido)) {
          this.editarVendaOuTrocaAmbiente(isVendaDoMesmoAmbiente, venda)
        } else {
          if (!vendaRedirecionada && venda.status_pedido !== Status.ReprovadoAnaliseCredito) {
            Aviso({
              title: 'O que deseja fazer?',
              text: '',
              buttons: {
                'Editar': async () => {
                  try {
                    const resultadoValidacao = await this.validarProposta(venda)

                    if (resultadoValidacao.status !== 200) {
                      notification(AlertTypes.ERROR, resultadoValidacao.msg_erro)
                      return
                    }
                    this.editarVendaOuTrocaAmbiente(isVendaDoMesmoAmbiente, venda)
                  } catch (error) {
                    notification(AlertTypes.ERROR, 'Erro ao verificar a proposta. Tente novamente mais tarde.')
                  }
                },
                'Apagar venda': {
                  color: 'error',
                  handler: () => {
                    this.deletar(venda.id_pedido)
                  }
                }
              },
              showCloseButton: true
            })
          } else {
            this.editarVendaOuTrocaAmbiente(isVendaDoMesmoAmbiente, venda)
          }
        }
      }
    },
    editarVendaOuTrocaAmbiente (isVendaDoMesmoAmbiente, venda) {
      if (isVendaDoMesmoAmbiente || this.is_usuario_logado_hierarquia) {
        this.irParaEdicao(venda)
      } else {
        this.alertRedirecionarAmbiente(venda)
      }
    },
    async irParaReservas () {
      await this.$router.push({ name: 'reservas' })
    },
    deletar (id_pedido) {
      this.$nextTick(() => {
        Aviso({
          text: 'Tem certeza que deseja apagar a venda? Esta ação não pode ser desfeita',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => {
              this.$http.delete(`vendas/${id_pedido}`)
                .then(() => {
                  Aviso({
                    text: 'Venda apagada com sucesso!',
                    buttons: {
                      'OK': () => this.$refs.datatable.reload()
                    }
                  })
                })
            }
          }
        })
      })
    },
    async irParaEdicao (venda) {
      try {
        this.$session.set('id_pedido_detalhes_venda', venda.id_pedido)

        if (this.is_usuario_logado_hierarquia) {
          await this.setarSessaoVendedorParaUsuarioGNRC(venda.flavor.nm_flavor, venda.id_empresa, venda.id_comissionado, venda.id_ponto_venda, venda.id_unidade_negocio)
        }

        if (venda.carrinho && venda.carrinho.qt_cotas && !isVendaNaoGerada(venda.status_pedido)) {
          return this.$router.replace({ name: 'detalhes-carrinho', params: { id_pedido: venda.id_pedido } })
        }

        if (venda.id_bem || venda.bem) {
          if (isVendaNaoGerada(venda.status_pedido)) {
            venda = await this.validaReservaExpirada(venda)
          }
          venda = await permiteEditar(venda)
        }
        const stat = this.getStatusProps(venda)

        if ([Status.AguardandoPagamento, Status.AguardandoAssinaturaContrato].includes(stat.label)) {
          if (venda.id_cliente > 1 && venda.id_grupo > 1) {
            this.$router.push({ name: 'detalhes-venda', params: venda })
          } else {
            this.$router.push({ name: 'cadastro', params: venda })
          }
        } else if (isVendaNaoGerada(venda.status_pedido) && venda.status_pedido !== Status.ReprovadoAnaliseCredito) {
          return this.$router.push({ name: 'cadastro', params: venda })
        } else {
          if (venda.status_pedido === 'Assinatura') {
            if (venda.assinatura_obrigatoria && this.verificaSeStatusEhDeFalha(venda)) {
              if (venda.origem_assinatura === 'pagamento') {
                if (venda.enviado) {
                  const tela = 'selecionar_assinatura'
                  this.$router.push({ name: 'contrato-venda', params: { venda, tela } })
                }
              }
            }
          } else {
            this.$router.push({ name: 'detalhes-venda', params: venda })
          }
        }
      } catch (err) {
        let startPaused = false
        if (err.message === ERRO_PROPOSTA_EXCLUIDA && this.$refs.datatable) {
          this.$refs.datatable.reload()
          startPaused = true
        }
        notification(AlertTypes.ERROR, err.message, 'Não foi possível editar a venda', false, false, startPaused)
        this.$router.push({ name: 'minhas-vendas', params: venda })
      }
    },
    async validaReservaExpirada (venda) {
      if (venda.id_reserva) {
        const result = await this.$http.get(`reserva/${venda.id_reserva}`)
        venda = { ...venda, ...result.data, reserva_completa: result.data.completa }
        let validade = venda.dt_validade.split(' ')[0]
        if (moment(validade).isBefore(moment().startOf('day'))) {
          if (venda.status_pedido === Status.ReprovadoAnaliseCredito) {
            return venda
          } else {
            venda = await asyncAlert('A reserva selecionada expirou, por favor selecione novamente as condições contratadas para continuar.').then(() => removerCondicoesContratadas(venda))
          }
        }
      }
      return venda
    },
    verificaSeStatusEhDeFalha (pedido) {
      return pedido.status !== 'Cancelado' && pedido.status !== 'Rejeitado' && pedido.status_pedido !== 'FalhaAlocacao'
    },
    verificaSeVendaFoiFinalizadaEEnviada (pedido) {
      return pedido.status_pedido === Status.Finalizado && pedido.enviado
    },
    verificaSeFormaDePagamentoELink (pedido) {
      return pedido.forma_pagamento === FormasPagamento.Link
    },
    verificaSeFormaDePagamentoECartaoOuBoletoEPagamentoNaoEnviado (pedido) {
      return [FormasPagamento.Cartao, FormasPagamento.Boleto].includes(pedido.forma_pagamento) && !pedido.pagamento_enviado
    },
    verificaSeAssinaturaEstaOk (pedido) {
      return (!pedido.assinatura_obrigatoria || !pedido.origem_assinatura === 'pagamento' || pedido.status === 'Assinado')
    },
    verificaSeELinkENaoFoiPago (pedido) {
      return (pedido.status_pedido === Status.Enviado || pedido.status_pedido === Status.AguardandoPagamento) && pedido.forma_pagamento === FormasPagamento.Link
    },
    verificaStatusDaAssinatura (pedido) {
      return (pedido.status_pedido === Status.AguardandoAssinaturaContrato && pedido.status === StatusContrato.ContratoAssinado) || (pedido.status_pedido === Status.AguardandoAssinaturaContrato && !pedido.assinatura_obrigatoria)
    },
    verificaSeFoiEnviadoENaoPago (pedido) {
      return pedido.enviado && !pedido.pagamento_enviado
    },
    getStatusProps (item) {
      return ListaStatusPedido[item.status_pedido]
    },
    isVendaDoMesmoAmbiente (id_flavor_utilizado_na_venda, id_empresa_utilizada_na_venda) {
      const flavor_atual = this.trazerFlavorPorEmpresaXNomeFlavor(this.flavor, this.id_empresa)
      const flavor_da_venda = this.trazerFlavorPorEmpresaXFlavor(id_flavor_utilizado_na_venda, id_empresa_utilizada_na_venda)
      if ((flavor_atual.id && flavor_da_venda.id)) {
        if (flavor_atual.id === flavor_da_venda.id) {
          return true
        }
      }
      return false
    },
    verificaSeStatusEhAguardandoPagamentoCliente (item) {
      if (
        (this.verificaSeVendaFoiFinalizadaEEnviada(item) &&
        this.verificaSeFormaDePagamentoELink(item) &&
        this.verificaSeAssinaturaEstaOk(item)) ||
        (this.verificaSeELinkENaoFoiPago(item) && this.verificaSeAssinaturaEstaOk(item))
      ) {
        return true
      }
    },
    trazerFlavorPorEmpresaXNomeFlavor (nm_flavor, id_empresa) {
      let flavor = this.flavorsEEmpresas.filter((flavor) => {
        return flavor.id_empresa_newcon === id_empresa && this.trazerNomeFlavor(flavor.nm_flavor) === this.trazerNomeFlavor(nm_flavor)
      })

      if (flavor.length === 0) {
        return false
      }
      return flavor[0]
    },
    trazerFlavorPorEmpresaXFlavor (id_flavor, id_empresa) {
      let flavor = this.flavorsEEmpresas.filter((flavor) => {
        return flavor.id_empresa_newcon === id_empresa && flavor.id === id_flavor
      })

      if (flavor.length === 0) {
        return false
      }
      return flavor[0]
    },
    trazerNomeFlavorPorEmpresaXFlavor (id_flavor, id_empresa) {
      let nomeFlavor = this.flavorsEEmpresas.filter((flavor) => {
        return flavor.id_empresa_newcon === id_empresa && flavor.id === id_flavor
      })

      if (nomeFlavor.length === 0) {
        return false
      }
      return this.trazerNomeFlavor(nomeFlavor[0].nm_flavor)
    },
    trazerNomeFlavorPorIdFlavor (id_flavor) {
      const flavor = this.flavors.find((flavor) => flavor.id === id_flavor)
      return this.trazerNomeFlavor(flavor?.nm_flavor ?? '')
    },
    alertRedirecionarAmbiente (pedido) {
      Aviso({
        text: 'A proposta foi realizada em outro empresa e/ou marca, deseja ser redirecionado para o ambiente correto ?',
        buttons: {
          'Cancelar': () => true,
          'Confirmar': () => {
            return this.verificarAmbiente(pedido)
          }
        }
      })
    },
    verificarAmbiente (pedido) {
      this.validarProposta(pedido).then((result) => {
        const erro = result.msg_erro
        const status = result.status
        if (status === 200) {
          this.redirecionarAmbiente(pedido)
        } else {
          notification(AlertTypes.ERROR, erro)
        }
      }).catch((error) => {
        notification(AlertTypes.ERROR, `Falha ao autenticar ambiente\n${error}`)
      })
    },
    async redirecionarAmbiente (pedido) {
      const flavor_da_venda = this.trazerFlavorPorEmpresaXFlavor(pedido.id_flavor_utilizado_na_venda, pedido.id_empresa_venda_logada)

      if (!flavor_da_venda.nm_flavor) {
        notification(AlertTypes.ERROR, 'Não foi identificado a parametrização da marca desta proposta. Favor entrar em contato com a Administradora.')
        return
      }
      const payloadParaCriptografar = this.getDadosParaManterSessao()
      payloadParaCriptografar.id_empresa = pedido.id_empresa_venda_logada
      payloadParaCriptografar.flavor = this.trazerNomeFlavor(flavor_da_venda.nm_flavor)
      this.criptografaInfoComBaseNoPedido(payloadParaCriptografar, pedido.id_pedido).then((isOk) => {
        if (isOk) {
          this.podeRedirecionarParaTrocaAmbiente = true
          const protocoloHttp = flavor_da_venda.url !== 'localhost:8080' ? 'https' : 'http'
          window.open(`${protocoloHttp}://` + flavor_da_venda.url + `/Sistema/#/troca_ambiente?id_pedido=${pedido.id_pedido}&id_empresa=${pedido.id_empresa_venda_logada}&flavor=${this.trazerNomeFlavor(flavor_da_venda.nm_flavor)}`, '_self')
        } else {
          Aviso({
            text: 'Erro ao redirecionar para o outro ambiente, tente novamente em instantes',
            buttons: {
              'Ok': () => true
            }
          })
        }
      })
    },
    criptografaInfoComBaseNoPedido (payloadParaCriptografar, chave) {
      const payloadCriptografado = JSON.stringify(payloadParaCriptografar)
      return this.$http.post('/cryptografar/salvando/com_chave', { conteudo: payloadCriptografado, chave: chave }).then((result) => {
        return true
      }).catch(() => false)
    },
    getDadosParaManterSessao () {
      const infosSessao = getKeysOfPersistentes()
      this.payloadParaCriptografar = {}
      infosSessao.forEach((info) => {
        this.payloadParaCriptografar[info] = this.$session.get(info)
      })
      return this.payloadParaCriptografar
    },
    async validarProposta (pedido) {
      if (this.is_usuario_logado_hierarquia) {
        return { status: 200 }
      }
      const resposta = await this.$http.post('/proposta/validar_proposta', { id_pedido: pedido.id_pedido, id_comissionado_logado: this.id_comissionado_venda, id_usuario_interno: this.id_usuario_interno, id_unidade_negocio: this.id_unidade_negocio }).then((result) => {
        return result.data
      })
      return resposta
    },
    async getFlavorsEEmpresas () {
      this.$http.get('/flavors_e_empresas').then((result) => {
        this.flavorsEEmpresas = result.data
      })
    },
    async getFlavors () {
      this.$http.get('/todos_flavors').then((result) => {
        this.flavors = result.data
      })
    },
    async getAdministradoras () {
      this.$http.get('/administradoras').then((result) => {
        this.administradoras = result.data
      })
    },
    trazerAdministradoraPorEmpresa (id_empresa) {
      let administradora = this.administradoras.find((administradora) => {
        return administradora.id_empresa_newcon === id_empresa
      })
      administradora = administradora?.nm_empresa_newcon ?? ''
      return administradora !== '' ? 'Administradora ' + administradora : ''
    },
    trazerNomeFlavor (flavor) {
      return flavor.toLowerCase().trim()
    }
  }
}
